<template>
  <div class="container-batch-layout">
    <div class="row g-0" style="width: 100vw">
      <span class="border-bottom">
        <button
          class="btn btn-batch-details"
          @click="toggleBatchDetails"
          :style="{ color: batchColor }"
        >
          Details
        </button>
        <button
          v-show="contentType === 'Transfer'"
          class="btn btn-folder-structure"
          @click="toggleFolderStructure"
          :style="{ color: folderColor }"
          :disabled="contentType !== 'Transfer'"
        >
          Folder Structure
        </button>
      </span>
      <div v-show="isLoading">Loading...</div>
      <div v-show="!isLoading">
        <div v-show="showBatchDetails" :key="detailsKey">
          <div v-if="contentType === 'Transfer'">
            <batch-item
              :transfer-id="batchId"
              :transfer-name="batchName"
              class="details"
            />
          </div>
          <div v-else-if="contentType === 'File Format Category Changes'">
            <file-format-category-changes
              :transfer-id="batchId"
              class="details"
            />
          </div>
          <div v-else-if="contentType === 'Workflow Definition'">
            <new-workflow-definition :workflow-id="batchId" class="details" />
          </div>
          <div v-else-if="contentType === 'Dissemination Request'">
            <package-for-dissemination :transfer-id="batchId" class="details" />
          </div>
          <div v-else-if="contentType === 'Reingest Request'">
            <package-for-reingest :transfer-id="batchId" class="details" />
          </div>
          <div v-else-if="contentType === 'Package Status Updates'">
            <package-status-update :transfer-id="batchId" class="details" />
          </div>
          <div v-else-if="contentType === 'System Configuration Updates'">
            <system-configuration-updates class="details"/>
          </div>
          <div v-else-if="contentType === 'Unknown'">
            <unknown-content :content-id="batchId" class="details" />
          </div>
          <div v-else></div>
        </div>
        <div v-if="contentType === 'Transfer'">
          <div v-show="showFolderStructure">
            <folder-structure class="folder">Folder Structure</folder-structure>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import BatchItem from "@/components/ContentReview/BatchItem.vue";
import FileFormatCategoryChanges from "@/components/ContentReview/FileFormatCategoryChanges.vue";
import FolderStructure from "@/components/ContentReview/Layout/FolderStructure.vue";
import NewWorkflowDefinition from "@/components/ContentReview/NewWorkflowDefinition.vue";
import PackageForDissemination from "@/components/ContentReview/PackageForDissemination.vue";
import PackageForReingest from "@/components/ContentReview/PackageForReingest.vue";
import PackageStatusUpdate from "@/components/ContentReview/PackageStatusUpdate.vue";
import SystemConfigurationUpdates from "@/components/ContentReview/SystemConfigurationUpdates.vue";
import UnknownContent from "@/components/ContentReview/UnknownContent.vue";
import { useContentStore } from "@/stores/content_review/content";
import { onMounted, ref, watch } from "vue";

const contentStore = useContentStore();
const showBatchDetails = ref(true);
const showFolderStructure = ref(false);
const batchColor = ref("blue");
const folderColor = ref("black");
const contentType = ref();
const batchId = ref();
const batchName = ref();
const detailsKey = ref(0);
const isLoading = ref(false);

const toggleFolderStructure = () => {
  showBatchDetails.value = false;
  showFolderStructure.value = true;
  batchColor.value = "black";
  folderColor.value = "blue";
};

const toggleBatchDetails = () => {
  showBatchDetails.value = true;
  showFolderStructure.value = false;
  batchColor.value = "blue";
  folderColor.value = "black";
};

onMounted(() => {
  contentType.value = contentStore.currentContent.contentType;
  batchId.value = contentStore.currentContent.contentId;
  batchName.value = contentStore.currentContent.name;
});

watch(
  () => contentStore.currentContent?.contentType,
  (newContentType) => {
    toggleBatchDetails();
    contentType.value = newContentType;
  }
);

watch(
  () => contentStore.currentContent?.contentId,
  (newId) => {
    toggleBatchDetails();
    batchId.value = newId;
  }
);

watch(
  () => contentStore.currentContent?.name,
  (newName) => {
    toggleBatchDetails();
    batchName.value = newName;
  }
);

const forceRerender = () => {
  detailsKey.value += 1;
};

watch(
  () => contentStore.loading,
  (update) => {
    isLoading.value = update;
    if (update == true) {
      forceRerender();
    }
  }
);
</script>

<style lang="scss" scoped>
.container-batch-layout {
  position: relative;
  float: left;
  display: flex;
  padding: 16px;
  max-width: 33.3vw;
  margin-bottom: 50px;
  overflow: auto;
}
.btn-batch-details {
  border: none;
  width: 50%;
}
.btn-folder-structure {
  border: none;
  width: 50%;
}
</style>
